import {
  useProjectFilesSelectedFileContent,
  useProjectFilesSelectedFilePath,
} from "../../../core_stores/useProjectFilesListStore";

const MIME_TYPES: { [key: string]: string } = {
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".gif": "image/gif",
  ".bmp": "image/bmp",
  ".webp": "image/webp",
  ".svg": "image/svg+xml",
  ".ico": "image/x-icon",
};

export function ProjectFilesImagePreview() {
  const selectedFilePath = useProjectFilesSelectedFilePath();
  const selectedFileContent = useProjectFilesSelectedFileContent();

  if (!selectedFileContent) {
    return null;
  }

  // Get the file extension and corresponding MIME type
  const extension =
    selectedFilePath?.toLowerCase().match(/\.[^.]+$/)?.[0] || ".png";
  const mimeType = MIME_TYPES[extension] || "image/png";

  const imageDataUrl = `data:${mimeType};base64,${selectedFileContent}`;

  return (
    <div className="flex-1 h-full overflow-auto flex items-center justify-center">
      <img
        src={imageDataUrl}
        alt="Selected file preview"
        className="max-w-full max-h-full object-contain 
        text-light-text dark:text-dark-text"
      />
    </div>
  );
}
